import { useEffect, useState } from 'react'

export const usePageContainerWidth = (ref: React.RefObject<HTMLElement>) => {
	const [width, setWidth] = useState(0)

	useEffect(() => {
		if (!ref.current) return

		const updateWidth = () => {
			if (ref.current) {
				setWidth(ref.current.offsetWidth)
			}
		}

		// Устанавливаем начальную ширину
		updateWidth()

		// Создаем ResizeObserver для отслеживания изменений размера
		const resizeObserver = new ResizeObserver(updateWidth)
		resizeObserver.observe(ref.current)

		// Также слушаем изменения размера окна
		window.addEventListener('resize', updateWidth)

		return () => {
			resizeObserver.disconnect()
			window.removeEventListener('resize', updateWidth)
		}
	}, [ref])

	return width
}
